<template>
  <div class="flex flex-col items-left text-white m-4">
    <div v-for="canal in urlsCanales" :key="canal.hipodromo" class="m-2 flex items-center rounded-lg shadow-xl">
      <a :href="canal.urlCanal" target="_blank">
        <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="youtube" class="p-2 w-24 h-24" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
          <path
            fill="currentColor"
            d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
          ></path>
        </svg>
      </a>
      <div class="flex flex-col flex-1">
        <a :href="canal.urlCanal" target="_blank" class="text-lg font-bold">{{ canal.hipodromo }}</a>
        <a :href="canal.urlCanal" target="_blank" class="text-sm font-thin">Click aquí para<br />abrir la transmisión</a>
      </div>
    </div>
    <router-link to="/menu" class="bg-paleta-3 hover:bg-blue-700 text-white font-bold mt-10 py-2 px-4 rounded">Inicio</router-link>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  created() {
    this.$store.dispatch("obtenerUrlsCanalesTransmision");
  },
  computed: {
    ...mapState({
      urlsCanales: state => state.urlsCanales
    })
  }
};
</script>
